<template>
  <div class="edit-video-box">
    <el-dialog
      :title="diaTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="param"
        :rules="rules"
        label-position="left"
        label-width="100px"
      >
        <div class="form-flex-box">
          <el-form-item label="帖子ID:" prop="vid">
            <el-input
              v-model="param.vid"
              size="small"
              placeholder="请输入帖子ID"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="价格:" prop="coins">
            <el-input
              v-model="param.coins"
              size="small"
              placeholder="请输入帖子价格"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="父专题:" prop="start">
          <el-select
            v-model="fatherSections"
            placeholder="请选择父专题"
            size="small"
            clearable
            @change="searchSelectSection"
          >
            <el-option
              v-for="(section, index) in sections"
              :key="index"
              :label="section.moduleName"
              :value="section.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="子专题:" prop="start">
          <el-select
            v-model="param.sectionID"
            placeholder="请选择子专题"
            size="small"
            clearable
          >
            <el-option
              v-for="(subSection, index) in searchSubSections"
              :key="index"
              :label="subSection.sectionName"
              :value="subSection.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架时间:" prop="reviewAt">
          <el-date-picker
            v-model="param.reviewAt"
            type="datetime"
            :editable="false"
            placeholder="请选择上架时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitDate()"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { changeDate } from "@/utils/global";
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      diaTitle: "帖子自动上线新增",
      diaType: "add",
      param: {
        vid: "",
        sectionID: "",
        reviewAt: "",
        coins: undefined
      },
      sections: [],
      searchSubSections: [],
      subSectionList: [],
      subSectionId: "",
      fatherSections: "",
      searchSubSectionId: "",
      rules: {
        vid: [{ required: true, message: "请输入帖子id", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getSections();
  },
  methods: {
    searchSelectSection() {
      // console.log(this.sections)
      this.sections.forEach((item) => {
        // console.log(item.moduleName)
        // console.log(this.fatherSections)
        if (item.id == this.fatherSections) {
          this.searchSubSections = item.allSection;
        }
      });
      // console.log(this.searchSubSections)
      // this.searchFatherSection
      this.param.sectionID = "";
    },
    getSections() {
      API.sectionList({}).then((res) => {
        if (res && res.code === 200) {
          this.sections = res.data;
        }
      });
    },
    // 提交
    submitDate() {
      if (this.diaType == "add") {
        this.param.coins = this.param.coins ? Number(this.param.coins) : undefined;
        API.addVidTimeOnline(this.param)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "新增成功！",
                type: "success",
              });
              this.$emit('update')
            } else {
              this.$message.error("新增失败！");
            }
            this.flag = false;
            this.handleClose();
          })
          .catch(() => {
            this.flag = false;
            this.handleClose();
          });
      } else {
        this.param.coins = this.param.coins ? Number(this.param.coins) : undefined;
        API.editVidTimeOnline(this.param)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "编辑成功！",
                type: "success",
              });
              this.$emit('update')
            } else {
              this.$message.error("编辑失败！");
            }
            this.flag = false;
            this.handleClose();
          })
          .catch(() => {
            this.flag = false;
            this.handleClose();
          });
      }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.dialogVisible = true;
      if (row) {
        // console.log(row);
        // console.log(row.timer.reviewAt);
        Object.assign(this.param, row.timer)
        this.handleSection();
        this.diaTitle = "帖子自动上线编辑";
        this.diaType = "edit";
      } else {
        this.diaType = "add";
        this.diaTitle = "帖子自动上线新增";
      }
    },
    handleSection() {
      this.sections.forEach((item) => {
        if (item.allSection) {
          item.allSection.forEach((i) => {
            if (i.id == this.param.sectionID) {
              this.fatherSections = item.id;
              this.searchSubSections = item.allSection;
              console.log(i, "-----------", this.fatherSections, this.searchSubSections);
            }
          });
        }
      });
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.param = {
        vid: "",
        sectionID: "",
        reviewAt: "",
        coins: undefined
      };
      this.searchSubSections = "";
      this.subSectionList = [];
      this.subSectionId = "";
      this.fatherSections = "";
      this.searchSubSectionId = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 300px;
  }
  .activity-box {
    /deep/ .el-input {
      width: 500px !important;
    }
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .el-select {
    width: 300px;
    /deep/ .el-input {
      width: 300px;
    }
  }
}
</style>
